import Loja from './loja'
import produtoRoutes from '@/modules/loja/produto/produto.routes'

export default [
    {
        path: '/',
        name: 'loja',
        component: Loja,
        children: [...produtoRoutes]
    }
]